import { useQuery } from "@tanstack/react-query";
import { fetchPasswordOptions } from "../api/auth";

// Read once per session: what a profile may offer changes only when the
// account gains a password or the firm fixes its mail, and both of those
// arrive through a reload.
export function usePasswordOptions() {
  return useQuery({
    queryKey: ["auth", "password-options"],
    queryFn: fetchPasswordOptions,
    staleTime: 60_000,
  });
}
